import React, { Children } from 'react';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const painPoints = ['Comés y te sentís inflamada', 'Gases, pesadez o dolor', "Comés 'bien' y seguís igual", 'No sabés qué te cae bien', 'Todo te hace mal'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-12 sm:py-16 lg:py-20 bg-brand-bg-beige" data-id="element-129">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-131">
          <h2 className="text-3xl sm:text-4xl font-poppins font-bold text-brand-text-dark mb-4" data-id="element-132">
            ¿Te pasa esto todos los días?
          </h2>
          <div className="w-24 h-1 bg-brand-accent-orange mx-auto rounded-full" data-id="element-133"></div>
        </motion.div>

        <motion.div className="bg-white rounded-3xl p-8 sm:p-10 shadow-lg border border-brand-bg-cream" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-134">
          <ul className="space-y-3 mb-6" data-id="element-135">
            {painPoints.map((point, index) => <motion.li key={index} variants={itemVariants} className="flex items-center gap-3" data-id="element-136">
                <div className="bg-red-50 p-1 rounded-full flex-shrink-0" data-id="element-137">
                  <X className="w-4 h-4 text-red-500" data-id="element-138" />
                </div>
                <span className="text-base text-brand-text-dark font-medium" data-id="element-139">
                  {point}
                </span>
              </motion.li>)}
          </ul>

          <motion.div variants={itemVariants} className="bg-brand-bg-cream p-4 rounded-2xl border-l-4 border-brand-accent-orange" data-id="element-140">
            <p className="text-brand-text-dark font-medium text-base" data-id="element-141">
              <span className="font-bold text-brand-accent-orange" data-id="element-142">
                Y lo peor:
              </span>{' '}
              evitás comidas, te frustrás y vivís incómoda.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}